import { SupplierCreateButton } from "./supplier.create.button";
import { SupplierCreateForm } from "./supplier.create.form";

export const SupplierCreate = {
    Button: SupplierCreateButton,
    Component: SupplierCreateForm,
}
